var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteRankImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: 3,
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.7,
    clipPath: "url(#clip0_4872_39453)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.877 24.1677H31.2098V25.8344H22.877V24.1677Z",
    fill: "url(#paint0_linear_4872_39453)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.877 27.5005H27.8769V29.1671H22.877V27.5005Z",
    fill: "url(#paint1_linear_4872_39453)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.5155 41.0837L41.2102 36.7739V13.4292C41.2102 13.4109 41.2011 13.3953 41.1992 13.3766C41.1954 13.3041 41.1809 13.2324 41.1568 13.1633C41.148 13.137 41.1381 13.1107 41.1267 13.0851C41.0863 12.9947 41.0298 12.9119 40.96 12.841L28.3715 0.24681C28.2994 0.175857 28.2148 0.119399 28.1217 0.0801083C28.098 0.0701901 28.0744 0.0614163 28.05 0.0541685C27.9771 0.0282286 27.9012 0.0133514 27.8241 0.00915523C27.8085 0.00915523 27.794 0 27.7784 0H11.2116C10.7515 0 10.3785 0.373076 10.3785 0.833508V6.66654H7.87869C7.41826 6.66654 7.04518 7.03961 7.04518 7.49966V10.8329H4.54542C4.08537 10.8329 3.71191 11.206 3.71191 11.6661V49.1667C3.71191 49.6267 4.08499 50.0002 4.54542 50.0002H32.8771C33.3375 50.0002 33.7106 49.6271 33.7106 49.1667V45.8334H36.2103C36.6708 45.8334 37.0438 45.4603 37.0438 45.0003V41.667H39.4005L42.1635 44.4304C43.055 45.3886 44.5546 45.4431 45.5128 44.5517C46.4714 43.6605 46.5256 42.161 45.6345 41.2028C45.596 41.1612 45.5567 41.1219 45.5155 41.0837ZM28.6157 2.84728L33.4905 7.72206L38.3652 12.5961H28.6157V2.84728ZM32.0439 48.3332H5.37855V12.5019H7.04518V44.9999C7.04518 45.4603 7.41826 45.8334 7.87869 45.8334H32.0439V48.3332ZM35.3772 44.1668H8.71182V8.33546H10.3785V40.8339C10.3785 41.2939 10.7515 41.667 11.2116 41.667H35.3772V44.1668ZM12.0451 40.0004V1.66892H26.949V13.4292C26.949 13.8893 27.3221 14.2627 27.7826 14.2627H39.5436V35.1073L36.3087 31.8724C39.2472 26.6932 37.431 20.1129 32.2518 17.1741C27.0726 14.2356 20.4919 16.0522 17.5535 21.2314C14.615 26.4106 16.4316 32.9909 21.6104 35.9297C25.2301 37.9832 29.7082 37.7703 33.1166 35.3831L37.7339 40.0004H12.0451ZM26.9609 35.6673C21.9446 35.6673 17.8781 31.6008 17.8781 26.5841C17.8781 21.5678 21.9446 17.5014 26.9609 17.5014C31.9772 17.5014 36.0436 21.5678 36.0436 26.5841C36.0375 31.5981 31.9745 35.6612 26.9609 35.6673ZM43.8401 43.4584C43.6524 43.4599 43.472 43.3855 43.34 43.252L34.5136 34.4241L35.5088 33.4292L39.5436 37.464V37.5006H39.5802L44.3375 42.2579C44.6122 42.5325 44.6122 42.9777 44.3375 43.2524C44.2051 43.3851 44.0251 43.4595 43.8374 43.4588H43.8401V43.4584Z",
    fill: "url(#paint2_linear_4872_39453)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.9602 18.6687C22.5882 18.6687 19.0439 22.2126 19.0439 26.5846C19.0439 30.957 22.5882 34.5008 26.9602 34.5008C31.3322 34.5008 34.8765 30.957 34.8765 26.5846C34.8715 22.2148 31.3299 18.6737 26.9602 18.6687ZM26.9602 32.8346C23.5087 32.8346 20.7106 30.0365 20.7106 26.585C20.7106 23.1334 23.5087 20.3353 26.9602 20.3353C30.4117 20.3353 33.2098 23.1334 33.2098 26.585C33.206 30.035 30.4102 32.8308 26.9602 32.8346Z",
    fill: "url(#paint3_linear_4872_39453)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4872_39453",
    x1: 4.40545,
    y1: 2.36291,
    x2: 48.4333,
    y2: 46.3907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4872_39453",
    x1: 1.90558,
    y1: 4.86265,
    x2: 45.9334,
    y2: 48.8905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4872_39453",
    x1: -1.03371,
    y1: 7.80394,
    x2: 42.9939,
    y2: 51.8308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4872_39453",
    x1: 3.57101,
    y1: 3.1988,
    x2: 47.5988,
    y2: 47.2258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4872_39453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteRankImage);
export default __webpack_public_path__ + "static/media/websiteRankImage.7c65db793a8bfff4e91a40f538fbd605.svg";
export { ForwardRef as ReactComponent };